import React from 'react';
import { RadioButtonGroup } from '@framework-controls/core';
// import SVPButton from 'src/components/SVPButtons/SVPButton';
import classNames from 'classnames';
import { strings } from 'src/localization/index';
import css from './DesktopDiagnoseModal.module.scss';
// import { diagnoseResponses } from '../../DiagnoseTree/DiagnoseTree';

interface IProps {
    title: string;
    selectedButton: string;
    diagnoseTree?: JSX.Element[];
    selectButtonHandler: (value: string) => void;
    theme?: string;
}

const DiagnoseTree = (props: IProps) => {
    const dialogTitleClass = classNames(
        css.dialogTitle,
        {
            [css.fontFamilyBaseFamily]: props.theme === 'mercedesBenz',
            [css.dialogTitleMazda]: props.theme === 'mazda',
            [css.dialogTitleGenesis]: props.theme === 'genesis',
        },
    );

    const subTitleStyles = classNames(
        {
            [css.subTitleAcura]: props.theme === 'acura',
        },
    );

    return (
        <div>
            <h4 id='h4LightBox' className={dialogTitleClass}>{strings.WalkThroughDiagnose}</h4>
            <h5 className={subTitleStyles} id='title'>{props.title}</h5>
            <RadioButtonGroup
                value={props.selectedButton}
                id='currentResponses'
                onChange={(_, value) => props.selectButtonHandler(value)}>
                {props.diagnoseTree}
            </RadioButtonGroup>
        </div>
    );
};

export default DiagnoseTree;